import { useState } from "react";
import { X } from "lucide-react";
import { LANGS, LANG_KEY, switchLang } from "@/i18n";

const HINT_KEY = "mfc_lang_hint";
const COPY = {
  es: ["¿Ver este sitio en español?", "Cambiar", "No, gracias"],
  fr: ["Voir ce site en français ?", "Changer", "Non merci"],
  zh: ["用中文浏览本网站？", "切换", "不用了"],
  hi: ["यह साइट हिन्दी में देखें?", "बदलें", "नहीं, धन्यवाद"],
  ar: ["هل تريد عرض هذا الموقع بالعربية؟", "تبديل", "لا، شكرًا"],
  pt: ["Ver este site em português?", "Mudar", "Não, obrigado"],
  bn: ["এই সাইটটি বাংলায় দেখবেন?", "বদলান", "না, ধন্যবাদ"],
  ru: ["Открыть сайт на русском?", "Переключить", "Нет, спасибо"],
};

const detect = () => {
  if (localStorage.getItem(LANG_KEY) || localStorage.getItem(HINT_KEY)) return null;
  const codes = (navigator.languages || [navigator.language || ""]).map((l) => l.toLowerCase().split("-")[0]);
  const first = codes.find((c) => LANGS.some(([k]) => k === c));
  return first && first !== "en" ? first : null;
};

export const LanguageHint = () => {
  const [lang, setLang] = useState(detect);
  if (!lang) return null;
  const [q, yes, no] = COPY[lang];
  const close = () => { localStorage.setItem(HINT_KEY, "1"); setLang(null); };
  return (
    <div lang={lang} dir={lang === "ar" ? "rtl" : "ltr"} data-no-translate data-testid="language-hint"
      className="relative z-40 bg-[#1C242B] text-[#FAF8F5] no-print animate-in slide-in-from-top duration-300">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 py-2.5 flex flex-wrap items-center gap-3 text-sm" style={{ letterSpacing: 0 }}>
        <span>{q}</span>
        <button onClick={() => { localStorage.setItem(HINT_KEY, "1"); switchLang(lang); }} data-testid="language-hint-switch"
          className="rounded-full bg-[#D96B43] px-4 py-1 font-semibold hover:bg-[#C05630] transition-colors">{yes}</button>
        <button onClick={close} data-testid="language-hint-dismiss" className="text-[#CBD5E1] hover:text-white underline-offset-4 hover:underline transition-colors">{no}</button>
        <button onClick={close} aria-label="Close" data-testid="language-hint-close" className="ms-auto p-1 rounded-full hover:bg-white/10 transition-colors"><X size={16} /></button>
      </div>
    </div>
  );
};
